import * as React from 'react';
import { headingSectionIntroFirstContext } from './context';
export function HeadingSectionIntroFirstProvider(props) {
    var _a = props.introFirst, introFirst = _a === void 0 ? false : _a, children = props.children;
    return (React.createElement(headingSectionIntroFirstContext.Provider, { value: introFirst }, children));
}
